import { lazy } from "react"

const ConversionsUnit = lazy(() =>  import('../../views/conversionsUnit'))

const ConversionsUnitIndex = [
  {
    path: '/conversiosnUnit',
    element: <ConversionsUnit/>

  }
]

export default ConversionsUnitIndex